module.exports = __webpack_public_path__ + "static/media/moduleManager.2a8f897a.svg";